export const selectionControlVertexShader = `#version 300 es

in vec2 a_position;
in vec2 a_texCoord;

uniform mat3 u_camViewProjection;
uniform mat3 u_model;

out vec2 v_texCoord;

void main() {
    mat3 u_matrix = u_camViewProjection * u_model;
    vec3 position = u_matrix * vec3(a_position, 1);
    gl_Position = vec4(position, 1);
    
    v_texCoord = a_texCoord;
}
`;

export const selectionControlFragmentShader = `#version 300 es

precision highp float;

in vec2 v_texCoord;

uniform float u_camScale;
uniform vec2 u_size;
uniform vec4 u_bgColor;

out vec4 outColor;

void main() {
    vec4 defaultBgColor = vec4(1, 1, 0.996, 1);
    // vec4 bgColor = vec4(1, 1, 0.996, 1);
    vec4 bgColor = (u_bgColor.a == 0.0) ? defaultBgColor : u_bgColor;
    vec4 borderColor = vec4(0, 0.6, 0.63, 1);
    
    float borderSize = 1.0; // in pixels
    
    vec2 pixel = u_size * v_texCoord; // 0.0 -> u_size
    
    if (
      (pixel.x <= borderSize || pixel.x >= u_size.x - borderSize)
      ||
      (pixel.y <= borderSize || pixel.y >= u_size.y - borderSize)
      ) {
        outColor = borderColor;
        return;
    }
    
    outColor = bgColor;
}`;
